import { Card, Tooltip } from 'antd';
import styles from './ContactsNode.module.css';
import { LinkOutlined } from '@ant-design/icons';

const ContactsNode = (props) => {
  const getTitleData = (props) => {
    // Coordinator needs to have the style hardcoded
    return props.coordinator ? (
      <Tooltip title="Coordenador">
        <span style={{ fontSize: '24px', fontWeight: '600' }}>{props.name}</span>
      </Tooltip>
    ) : (
      <span class={styles['node-title']}>{props.name}</span>
    );
  };
  return (
    <>
      <Card className={styles.node}>
        <Card.Meta title={getTitleData(props)} description={<span>{props.role}</span>}></Card.Meta>
        <Card.Meta
          title={<span class={styles['node-title']}></span>}
          description={
            <a href={props.link}>
              <LinkOutlined title="Visitar Página" style={{ fontSize: '150%', color: 'white'}}/>
            </a>
          }></Card.Meta>
      </Card>
    </>
  );
};

export default ContactsNode;
